
export function payMethodReducer(
  state = {
    profileData: [],
  },
  action) {
  switch (action.type) {

    case 'PAYMENT_SET':
      return {
        ...state,
        profileData: action.val
      };

    default:
      return state;
  }
}
